import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AppState } from 'src/app/store/app.state';
import { getApplicantDetails, getUserProfile } from 'src/app/store/selectors/account.selector';
import { getShowBackFront } from 'src/app/store/selectors/shared.selector';
import * as QRCode from 'qrcode';
import { addYears, format } from 'date-fns';

@Component({
  selector: 'app-view-sp-id',
  templateUrl: './view-sp-id.component.html',
  styleUrls: ['./view-sp-id.component.scss']
})
export class ViewSpIdComponent implements OnInit {

  @Input() card: any;
  @Input() org: any;

  getShowBackFront$: Observable<any>;
  showBackFront: any;

  getUserProfile$: Observable<any>;
  userProfile: any;

  getApplicantDetails$: Observable<any>;
  applicantDetails: any;

  sectionShow = 1;

  ngUnsubscribe = new Subject();

  qrCode: SafeHtml = '';

  constructor(
    private store: Store<AppState>,
    private sanitizer: DomSanitizer,
  ) {
    this.getShowBackFront$ = this.store.select(getShowBackFront);
    this.getApplicantDetails$ = this.store.select(getApplicantDetails);
    this.getUserProfile$ = this.store.select(getUserProfile);
  }

  ngOnInit(): void {
    this.getUserProfile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if (res) {
        this.userProfile = res;
      }
    });

    this.getApplicantDetails$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (res) => {
      if(res){     
        this.applicantDetails = res;
        // const allowedStatuses = ['verified'];

        // const filteredDemographics = res.demographic.filter((d: any) =>
        //   allowedStatuses.includes(d.status)
        // );
        // this.applicantDetails = {
        //   ...res,
        //   demographic: filteredDemographics
        // };

        const svg = await QRCode.toString(JSON.stringify(this.applicantDetails?.qrcode), {
              type: 'svg', margin: 0, width: 180, errorCorrectionLevel: 'H'
            });

        const svgWithLogo = svg.replace(
          '</svg>',
          `<rect x="31.5" y="31.5" width="26" height="26" fill="white" />` +
          `<image x="34.5" y="35.5"
                  width="20" height="20"
                  xlink:href="/assets/img/admin/id-template/dswd-logo.png" /></svg>`
        );
        this.qrCode = this.sanitizer.bypassSecurityTrustHtml(svgWithLogo);
      }
    });

    this.getShowBackFront$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.sectionShow = res;
      }
    });
  }

  org_logo(): string {
    const logo = this.userProfile?.scp_org?.contents?.find(orgCont => orgCont?.type === 'header1');
    return (logo) ? logo?.valueURL : '';
  }

  userPhoto(): string {
    return this.card?.picture ?? '/assets/img/admin/broken-image.png';
  }

  formatBirthday(dateStr) {
    if (!dateStr) return '';

    const [year, month, day] = dateStr.split('-').map(Number);
    const localDate = new Date(year, month - 1, day);
    return format(localDate, 'MM/dd/yyyy');
  }

  get getBenifitCode(){
    const typesString = this.applicantDetails?.demographic_benefits?.filter((e) => e?.status == 'active')
      ?.map(d => d?.benefit?.benefitCode)
      .join(', ');

      return typesString
  }

  get getSoloParentCategory(){
    const typesString = this.applicantDetails?.demographic?.filter((e) => e?.code == 'SP' && e?.status == 'verified')
      ?.map(d => d?.typeValue)
      .join(', ');
      return typesString?.toUpperCase();
  }

  get getLguContent(){
    const getOrganization = this.applicantDetails?.organizations?.find((e) => e?.orgType == 'LGU');
    if(getOrganization){
      return getOrganization
    } else{
      const getOrganization = this.applicantDetails?.scp_org;
      return getOrganization
    }
  }

  get profilePicture(){
    return this.applicantDetails?.documents?.find((e) => e?.type?.docName == 'Profile Picture')?.docUrl
  }

  get signature(){
    return this.applicantDetails?.documents?.find((e) => e?.type?.docName == 'eSignature')?.docUrl
  }

  get spId(){
    return this.applicantDetails?.documents?.find((e) => e?.type?.docName == 'Solo Parent ID')
  }

  get familyBeneficiary(){
    return this.applicantDetails?.family_members?.filter((e) => e?.beneficiary == 'yes')
  }
  
  getExpiration(date) {
    if (date) {
      const newDate = addYears(new Date(date), 1);
      return format(newDate, 'MMMM dd, yyyy');
    }
    return date;
  }
}
